import { formatPrismicProduct } from './product';
import { Query } from '@prismicio/client';
import { PrismicDocument } from '@prismicio/client';
import { ICollectionProductBasket, IShopifyProduct } from '@monofront/types';

interface IProductBasketItem {
  product: IShopifyProduct;
  preprod_product: IShopifyProduct;
}

export const getFormattedCollectionProductBasket = (
  collectionProductBasket: Query | null,
  title?: string | null,
  descriptionMobile?: string | null,
): ICollectionProductBasket | null => {
  if (!collectionProductBasket?.results.length) {
    return null;
  }

  const formattedCollectionProductBasket: PrismicDocument[] =
    collectionProductBasket?.results
      .filter((productBasket: any) => productBasket.type === 'productbasket')
      .map((productBasket: any) => {
        return {
          ...productBasket,
          data: {
            ...productBasket.data,
            body: [
              {
                ...productBasket.data.body[0],
                items:
                  productBasket.data.body.length === 0
                    ? []
                    : productBasket.data.body[0].items
                        .filter(
                          ({
                            product,
                            preprod_product,
                          }: IProductBasketItem) => {
                            return product || preprod_product;
                          },
                        )
                        .map(
                          ({
                            product,
                            preprod_product,
                          }: IProductBasketItem) => {
                            if (!product && Boolean(preprod_product)) {
                              return formatPrismicProduct(preprod_product);
                            }

                            return formatPrismicProduct(product);
                          },
                        ),
              },
            ],
          },
        };
      })
      .filter((productBasket) => {
        return (
          productBasket.data.body.length &&
          productBasket.data.body[0].items.length
        );
      });

  return {
    products: formattedCollectionProductBasket,
    title,
    descriptionMobile,
  };
};
